import Alpine from "alpinejs";

export const alpineDataBlogFilters = () =>
  Alpine.data("blogFilters", (blogHandle) => ({
    loading: false,
    blogHandle: blogHandle,
    filters: [],
    // unhandleize blog handle
    unhandleize(string) {
      return string.replace(/-/g, " ");
    },
    init() {
      const tags =
        new URL(window.location.href).pathname
          .split("tagged/")[1]
          ?.split("+") || [];

      // Add tags to state if they exist
      if (tags.length) {
        this.filters = tags;
      }
    },
    filterBlogSingle(newFilter) {
      this.loading = true;
      this.$refs[`allArticles`].checked = false;
      this.$refs[`filters`]
        .querySelectorAll("input")
        .forEach((input) => (input.checked = false));
      let filterString = "";

      // make sure the newFilter is the only filter selected
      this.filters = [newFilter];

      // create the filter string to append to the url for the fetch request
      if (this.filters.length) {
        filterString = this.filters.reduce(
          (string, item) => (!string ? `/tagged/${item}` : `${string}+${item}`),
          null
        );
      }
      const blogContainer = document.querySelector("#blogContainer");

      // add opacity to the blog container to indicate loading
      blogContainer.style.opacity = 0.3;
      fetch(`/blogs/${this.blogHandle}${filterString}`)
        .then((response) => response.text())
        .then((data) => {
          // create a new div, set the html and replace it in the dom
          let html_div = document.createElement("div");
          html_div.innerHTML = data;
          let html_dom = html_div.querySelector("#blogContainer").innerHTML;
          blogContainer.innerHTML = html_dom;
          // update url without refreshing the page
          history.replaceState(
            null,
            null,
            `/blogs/${this.blogHandle}${filterString}`
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          blogContainer.style.opacity = 1;
          this.loading = false;
        });
    },
    filterBlogMultiple(newFilter) {
      this.loading = true;
      this.$refs[`allArticles`].checked = false;
      let filterString = "";
      // if the newFilter has already been selected, removed it instead
      if (this.filters.includes(newFilter)) {
        this.filters = [...this.filters].filter((item) => item !== newFilter);
      } else {
        // add the newFilter to the selected filters
        this.filters = [...this.filters, newFilter];
      }
      // create the filter string to append to the url for the fetch request
      if (this.filters.length) {
        filterString = this.filters.reduce(
          (string, item) => (!string ? `/tagged/${item}` : `${string}+${item}`),
          null
        );
      }
      const blogContainer = document.querySelector("#blogContainer");
      // add opacity to the blog container to indicate loading
      blogContainer.style.opacity = 0.3;
      fetch(`/blogs/${this.blogHandle}${filterString}`)
        .then((response) => response.text())
        .then((data) => {
          // create a new div, set the html and replace it in the dom
          let html_div = document.createElement("div");
          html_div.innerHTML = data;
          let html_dom = html_div.querySelector("#blogContainer").innerHTML;
          blogContainer.innerHTML = html_dom;
          // update url without refreshing the page
          history.replaceState(
            null,
            null,
            `/blogs/${this.blogHandle}${filterString}`
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          blogContainer.style.opacity = 1;
          this.loading = false;
        });
    },
    clearFilters() {
      this.loading = true;
      this.filters = [];
      this.$refs[`allArticles`].checked = true;
      this.$refs[`filters`]
        .querySelectorAll("input")
        .forEach((input) => (input.checked = false));
      const blogContainer = document.querySelector("#blogContainer");
      // add opacity to the blog container to indicate loading
      blogContainer.style.opacity = 0.3;
      fetch(`/blogs/${this.blogHandle}`)
        .then((response) => response.text())
        .then((data) => {
          // create a new div, set the html and replace it in the dom
          let html_div = document.createElement("div");
          html_div.innerHTML = data;
          let html_dom = html_div.querySelector("#blogContainer").innerHTML;
          blogContainer.innerHTML = html_dom;
          // update url without refreshing the page
          history.replaceState(null, null, `/blogs/${this.blogHandle}`);
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          blogContainer.style.opacity = 1;
          this.loading = false;
        });
    },
  }));
